var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1825_22413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5898C9.85652 15.5898 11.637 14.8523 12.9497 13.5396C14.2625 12.2268 15 10.4464 15 8.58984C15 6.73333 14.2625 4.95285 12.9497 3.6401C11.637 2.32734 9.85652 1.58984 8 1.58984C6.14348 1.58984 4.36301 2.32734 3.05025 3.6401C1.7375 4.95285 1 6.73333 1 8.58984C1 10.4464 1.7375 12.2268 3.05025 13.5396C4.36301 14.8523 6.14348 15.5898 8 15.5898ZM8 16.5898C10.1217 16.5898 12.1566 15.747 13.6569 14.2467C15.1571 12.7464 16 10.7116 16 8.58984C16 6.46811 15.1571 4.43328 13.6569 2.93299C12.1566 1.4327 10.1217 0.589844 8 0.589844C5.87827 0.589844 3.84344 1.4327 2.34315 2.93299C0.842855 4.43328 0 6.46811 0 8.58984C0 10.7116 0.842855 12.7464 2.34315 14.2467C3.84344 15.747 5.87827 16.5898 8 16.5898Z",
    fill: "#00BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92995 7.17774L6.63995 7.46474L6.55795 7.84474L7.00795 7.92774C7.30195 7.99774 7.35995 8.10374 7.29595 8.39674L6.55795 11.8647C6.36395 12.7617 6.66295 13.1837 7.36595 13.1837C7.91095 13.1837 8.54395 12.9317 8.83095 12.5857L8.91895 12.1697C8.71895 12.3457 8.42695 12.4157 8.23295 12.4157C7.95795 12.4157 7.85795 12.2227 7.92895 11.8827L8.92995 7.17774Z",
    fill: "#00BE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.08984C8.55228 6.08984 9 5.64213 9 5.08984C9 4.53756 8.55228 4.08984 8 4.08984C7.44772 4.08984 7 4.53756 7 5.08984C7 5.64213 7.44772 6.08984 8 6.08984Z",
    fill: "#00BE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1825_22413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.589844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.b8ee64e6e587453ff03309335be0f527.svg";
export { ForwardRef as ReactComponent };